import React, { createContext, useState } from 'react';

const CreateContext = createContext();

const CreateProvider = ({ children }) => {
    const [editContact, setEditContact] = useState(null);
    const [editMessage, setEditMessage] = useState(null);
    const [editEvent, setEditEvent] = useState(null); // Contains the event id if it is in edit mode
    const [duplicateEvent, setDuplicateEvent] = useState(null); // Contains the event id if it is in duplicate mode
    const [editRessource, setEditRessource] = useState(null); // Contains the ressource id if it is in edit mode
    const [duplicateRessource, setDuplicateRessource] = useState(null); // Contains the ressource id if it is in duplicate mode
    const [messageRessource, setMessageRessource] = useState(null); // Contains the ressource id if it is in message creation
    const [isNewStory, setIsNewStory] = useState(false);
    const [openPopUpAddNewContact_CreationMode, setOpenPopUpAddNewContact_CreationMode] = useState(false);
    const [openPopUpAddNewMessage_CreationMode, setOpenPopUpAddNewMessage_CreationMode] = useState(false);
    const [openPopUpAddNewEvent_CreationMode, setOpenPopUpAddNewEvent_CreationMode] = useState(false);
    const [openPopUpAddNewRessource_CreationMode, setOpenPopUpAddNewRessource_CreationMode] = useState(false);
    const [firstSelectedContact, setFirstSelectedContact] = useState(null);
    const [pendingIconDeletions, setPendingIconDeletions] = useState([]); // List of icon paths to delete on save
    const [pendingRessourceDeletions, setPendingRessourceDeletions] = useState([]); // List of ressource paths to delete on save

    // Add an icon path to the pending deletions list
    const addPendingIconDeletion = (iconPath) => {
        setPendingIconDeletions(prev => [...prev, iconPath]);
    };

    // Clear pending deletions (after save)
    const clearPendingIconDeletions = () => {
        setPendingIconDeletions([]);
    };

    // Add a ressource path to the pending deletions list
    const addPendingRessourceDeletion = (ressourcePath) => {
        setPendingRessourceDeletions(prev => [...prev, ressourcePath]);
    };

    // Clear pending ressource deletions (after save)
    const clearPendingRessourceDeletions = () => {
        setPendingRessourceDeletions([]);
    };

    const value = {
        editContact, setEditContact,
        editMessage, setEditMessage,
        editEvent, setEditEvent,
        duplicateEvent, setDuplicateEvent,
        editRessource, setEditRessource,
        duplicateRessource, setDuplicateRessource,
        messageRessource, setMessageRessource,
        isNewStory, setIsNewStory,
        openPopUpAddNewContact_CreationMode, setOpenPopUpAddNewContact_CreationMode,
        openPopUpAddNewMessage_CreationMode, setOpenPopUpAddNewMessage_CreationMode,
        openPopUpAddNewEvent_CreationMode, setOpenPopUpAddNewEvent_CreationMode,
        openPopUpAddNewRessource_CreationMode, setOpenPopUpAddNewRessource_CreationMode,
        firstSelectedContact, setFirstSelectedContact,
        pendingIconDeletions, addPendingIconDeletion, clearPendingIconDeletions,
        pendingRessourceDeletions, addPendingRessourceDeletion, clearPendingRessourceDeletions
    }

    return (
        <CreateContext.Provider value={value}>
            {children}
        </CreateContext.Provider>
    );
}

export { CreateProvider, CreateContext };